const VALIDATION_ERROR_CODE = "validation_error";

export type BackendValidationError = {
  error_code?: string;
  attributes?: Record<string, unknown>;
};

export const isBackendValidationError = (error: unknown): error is BackendValidationError =>
  typeof error === "object" && error !== null && ("error_code" in error || "attributes" in error);

export const mapBackendErrorToFormFields = (
  error: BackendValidationError = {},
  fieldMap: Record<string, string>
): string[] => {
  const attributes = error?.attributes;

  if (
    error.error_code !== VALIDATION_ERROR_CODE ||
    !attributes ||
    typeof attributes !== "object" ||
    Array.isArray(attributes)
  ) {
    return [];
  }

  const backendFieldKeys = Object.keys(attributes);
  if (!backendFieldKeys.length) return [];

  return backendFieldKeys.map((key) => fieldMap[key]).filter(Boolean);
};
